module.exports = __webpack_public_path__ + "static/media/BrandTagLogo.ba08cc99.svg";